
/* injects from baggage-loader */

'use strict'

import { genSecureHex } from '_appRoot/core/services/secure-random';

import StageBaseController from '../stage-base.controller';

import { FishIcons, initFeedbackTexts, feedbackTexts, thirdChallengeText, helpTpl } from './stage-one.const';

import { findIndex, shuffle, random } from 'lodash';

export default class StageOneController extends StageBaseController{
    constructor($log, $rootScope, $state, $timeout, Dialog, Trophies, Session) {
        'ngInject';        
        super($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, 'main.stage-one'); 
        
        this.state = {
            totalItems: 0,
            inFocus: false
        };

        this.name = "Stage 1";

        this.groupFishQuantity = {
            boto:random(20, 33, false),
            peixeboi:random(20, 33, false),
            tucunare:random(20, 33, false)
        }

        this.step = 1;

        this.items = [];

        this.model = {
            boto: [],
            tucunare: [],
            peixeboi: []
        };

        this.count_fish = {
            boto:0,
            peixeboi:0,
            tucunare:0
        }  

        this.groupFish = {
            boto: [],
            tucunare: [],
            peixeboi: []
        };

        
              
    }

    $onInit(){

        let updates = this.Session.get();
        let stageIndex = findIndex(updates.stages, { name: this.name });

        this.createItems();

        this.groupFish.boto = this.createGroupItem('boto',this.groupFishQuantity.boto, 150, 250, 910, 1120);
        this.groupFish.peixeboi = this.createGroupItem('peixeboi',this.groupFishQuantity.peixeboi, 300, 400, 910, 1120);
        this.groupFish.tucunare = this.createGroupItem('tucunare',this.groupFishQuantity.tucunare, 450, 550, 910, 1120);

        updates.stages[stageIndex].timesEntered++;
       
        this.Dialog.showFeedbackIbama('label-peixeboi', initFeedbackTexts, () => {
            if (updates.stages[stageIndex].firstRun) {
                updates.stages[stageIndex].firstRun = false;
                this.Session.save(updates);
                this.openHelp();
            } else{
                this.Session.save(updates);
            }
        });

        //Mudando cenário para animação dos peixes
        this.$rootScope.$on('finish:peixeboi:step1', () => this.animateFish())
    }
    
    openHelp(){
        this.Dialog.showBigAlert('label-help', helpTpl);
    }

    fishMove() {
      let elem = document.getElementById("fishesMoving");   
      let pos = -400;
      let id = setInterval(frame, 5);
      function frame() {
        if (pos === 500) {
          clearInterval(id);
        } else {
          pos++; 
          
          elem.style.left = pos + "px"; 

        }
      }
    }

    animateFish(){
        this.step++;
        this.fishMove();
        this.$timeout( () => {
            this.Dialog.showFeedback('label-opa', thirdChallengeText, 'btn-ok', () => {
                this.step++;
                this.Dialog.showQuizPeixeboi(3, this.groupFishQuantity, () => false)
                
            })
                    
        },5000);
        

        
        
    }

    // Feedback callbacks
    //Call quiz
    onShowFeedbackSuccess(){
        this.$timeout(() => {
            this.state.inFocus = true;
            
            this.count_fish.boto = this.model.boto.length;
            this.count_fish.peixeboi = this.model.peixeboi.length;
            this.count_fish.tucunare = this.model.tucunare.length;

            this.Dialog.showQuizPeixeboi(1, this.count_fish, this.onShowGraphOnca.bind(this))
        }, 1200);
    }

    onShowGraphOnca(){
        
        this.state.inFocus = false;
    }
       
    onDrop($event, data, items, type){
        if(type === data.type){
            let indexOf = findIndex(items, { id: data.id });            
            this.model[data.type].push(data);            
            this.items.splice(indexOf, 1);

            if(this.isValid()){
                
                // this.$timeout(() => {alert(feedbackTexts); }, 1200);
                this.$timeout(() => {
                    

                    this.Dialog.showFeedbackIbama('label-peixeboi', feedbackTexts, this.onShowFeedbackSuccess.bind(this));
                    
                }, 1200);
            }
        }


        
    }
    
    dropValidate(type, data){
        return type === data.type;
    }

    // Generators

    createItems(){
        let quantities = [random(1, 6, false),random(1, 6, false),random(1, 6, false)];
        //let quantities = [1,1,1];
        quantities = shuffle(quantities);

        let boto = this.createItem('boto',quantities[0]);
        let tucunare = this.createItem('tucunare',quantities[1]);
        let peixeboi = this.createItem('peixeboi',quantities[2]);

        let items = [];
        
        items = items.concat(boto);
        items = items.concat(tucunare);
        items = items.concat(peixeboi);

        this.items = shuffle(items);
        this.state.totalItems = this.items.length;
    }


    createItem(type, total){
        let items = [];
        
        if(!total){
            total = random(1, 6, false);
        }
            
        for(let i = 0; i < total; i++){
            let item = {
                id: genSecureHex(),
                type: type,
                images: {
                    default: FishIcons[type].default
                }
            }

            items.push(Object.assign(this.createItemPosition(), item));
        }

        return items;
    }

    createItemPosition(){
        return {
            position:{
                top: `${random(0, 340)}px`,
                left: `${random(0, 575)}px`
            }
        }
    }

    
     createGroupItem(type, total,top1, top2, left1, left2){
        let items = [];
        
        if(!total){
            total = random(1, 6, false);
        }
            
        for(let i = 0; i < total; i++){
            let item = {
                id: genSecureHex(),
                type: type,
                images: {
                    default: FishIcons[type].default
                }
            }

            items.push(Object.assign(this.createGroupItemPosition(top1, top2, left1, left2), item));
        }

        return items;
    }

    createGroupItemPosition(y, yMax, x, xMax){
        return {
            position:{
                top: `${random(y, yMax)}px`,
                left: `${random(x,xMax)}px`
            }
        }
    }

    isValid(){
        let totalModelItems = 0;

        angular.forEach(this.model, object => {
            totalModelItems += object.length;
        });

        return this.state.totalItems === totalModelItems;
    }
    
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.controller.js